module.exports = __webpack_public_path__ + "static/media/turnet-townsend.391d7f9c.png";